export default __webpack_public_path__ + "static/media/Gmail_Icon.e170b065.png";